import PropTypes from 'prop-types';
import CharacterCounter from 'apps/interactions/components/character-counter';
import { useProposalFormContext } from '../context/proposal-form-context';
import { DynamicSearchAndSelect } from '@evertrue/sdk';
import { useAdditionalProposalCategoriesSearch } from 'hooks/use-proposal-fields-search';

const AdditionalProposalCategoryField = ({ onChange, onBlur, name, value, required = false, field, meta, helpers }) => {
  const { standardFieldsConfig } = useProposalFormContext();
  const maxLength = standardFieldsConfig?.additional_proposal_category?.max_length;

  const { results, loading, query, handleSearch, clearSearch } = useAdditionalProposalCategoriesSearch();

  const handleSelect = (selectedValue) => {
    if (onChange) {
      // Extract the actual value from the selectedValue object
      const actualValue = selectedValue?.value || selectedValue;
      const syntheticEvent = {
        target: { name, value: actualValue },
        currentTarget: { name, value: actualValue },
      };
      onChange(syntheticEvent);
    }
  };

  return (
    <>
      <DynamicSearchAndSelect
        value={value || ''}
        onSelect={handleSelect}
        placeholder={'Add Additional Proposal Category...'}
        searchResults={results}
        isSearching={loading}
        query={query}
        handleSearch={handleSearch}
        clearSearch={clearSearch}
        freeSolo={true}
        autoSaveOnBlur={true}
      />
      {maxLength && <CharacterCounter limit={maxLength} count={(value || '').length} />}
    </>
  );
};

AdditionalProposalCategoryField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default AdditionalProposalCategoryField;
